import { useMemo } from 'react'
import styled from 'styled-components'

import { InjectionTokens } from '@/controller/tokens'

import { RouteState, RouteStateProps } from '@/domain/states/RouteState'
import { SettingsState, SettingsStateProps } from '@/domain/states/SettingsState'

import { useBehaviorSubject } from '@/presentation/hooks/useBehaviorSubject'
import { useGlobalState } from '@/presentation/hooks/useGlobalState'
import {
  ScreenElementsState,
  ScreenElementsStateProps
} from '@/presentation/modules/MapScreen/states/ScreenElementsState'
import { getMapOverlayHorizontalOffset } from '@/presentation/modules/MapScreen/utils/getMapOverlayHorizontalOffset'
import { appZIndex } from '@/presentation/utils/zIndexMapper'

function RouteGuidePresenter() {
  const [routeState] = useGlobalState<RouteState, RouteStateProps>(InjectionTokens.RouteState)
  const [settingsState] = useGlobalState<SettingsState, SettingsStateProps>(InjectionTokens.SettingsState)
  const screenElementsState = useBehaviorSubject<ScreenElementsStateProps>(ScreenElementsState)

  const guideLabel = useMemo(
    () =>
      !routeState.activeRoute
        ? 'Defina o aeródromo de partida'
        : routeState.activeRoute.waypoints.length === 1
          ? 'Defina o aeródromo de destino'
          : 'Escolha pontos intermediários',
    [routeState.activeRoute?.waypoints.length]
  )

  if (
    routeState.activeRoute?.waypoints.length >= 3 ||
    settingsState.waypointInsertionMode === 'sequential' ||
    screenElementsState.meteorologyControl
  )
    return null

  return (
    <Guide $horizontalOffset={getMapOverlayHorizontalOffset(screenElementsState)}>
      <p>{guideLabel}</p>
    </Guide>
  )
}

export { RouteGuidePresenter }

interface GuideProps {
  $horizontalOffset: number
}

const Guide = styled.div<GuideProps>`
  position: absolute;
  bottom: 23px;
  left: calc(50% + ${({ $horizontalOffset = 0 }) => `${$horizontalOffset}px`});
  transform: translateX(-50%);

  width: fit-content;
  height: 40px;
  padding: 0 15px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutralL3};
  box-shadow: 0px 1px 4px 2px ${({ theme }) => `${theme.colors.secondaryD1}80`};
  z-index: ${appZIndex.ROUTER_GUIDE};

  & p {
    color: ${({ theme }) => theme.colors.secondaryD1};
    ${({ theme }) => theme.fonts.infoMD};
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    @media (max-width: 350px) {
      ${({ theme }) => theme.fonts.infoSM};
    }
  }
`
